import articleApiImpl from '../api/article-api';
import { bookmarksWidget as bookmarksWidgetImpl } from '../widgets/bookmarks/bookmarks-widget';
import type { DeepDiveWidget } from '@/core/widgets/export';
import type { ArticleApi } from './contracts';

export type { Article, ArticleApi } from './contracts';
export { subject } from '../model/concept-item';
export { default as ArticleList } from '../components/articles/article-list';
export { default as ArticleModal } from '../components/articles/article-modal';
export { articleSearchResultType } from '../search/article-search-result-type';
export { default as ArticleViewPage } from '../pages/article-view-page';
export { PinnedArticleWidgetFactory } from '../widgets/pinned/pinned-article-widget-factory';
export { PinnedSeriesWidgetFactory } from '../widgets/pinned/pinned-series-widget-factory';
export { PinnedSeriesWidget } from '../widgets/pinned/pinned-series-widget';
export { TechnicalAnalysisWidgetFactory } from '../widgets/pinned/technical-analysis-widget-factory';
export { BulletListWidget } from '../widgets/scrollers/bullet-list-widget';
export { MainwireScrollerWidget } from '../widgets/scrollers/mainwire-scroller-widget';
export { SearchWidget } from '../widgets/search/search-widget';
export const articleApi: ArticleApi = articleApiImpl;
export const bookmarksWidget: DeepDiveWidget = bookmarksWidgetImpl;
